import React from 'react'
import clsx from 'clsx'
import useShowMore from 'modules/common/hooks/useShowMore'

interface Proptypes {
  item: { items: any[] } & any
  renderComponent: any
  resetQuery?: any
}

const ListItem = (props: Proptypes) => {
  const { renderComponent, resetQuery } = props
  const item: {
    items?: any[]
    key?: string
    label?: string
    isRefined: boolean
  } = props.item

  const { showMoreProps, ShowMore, visibleItems } = useShowMore({
    showMore: item.items && Boolean(item.items.length),
    limit: 5,
    showMoreLimit: 10,
    items: item.items || [],
  })

  const itemHasChildren: boolean = (item?.items || []).length > 0
  return (
    <li
      key={item.key || item.label}
      className={clsx('item', {
        'item--selected': item.isRefined,
        'item--noRefinement': true,
        'item--parent': itemHasChildren,
      })}
    >
      {renderComponent(item, resetQuery)}
      {itemHasChildren && (
        <ul className={clsx('item', 'list--child')}>
          {visibleItems.map(
            (item: Proptypes & { key?: string; label?: string }) => (
              <ListItem
                key={item.key || item.label}
                item={item}
                renderComponent={renderComponent}
              />
            ),
          )}
          <ShowMore key="showMore" {...showMoreProps} />
        </ul>
      )}
    </li>
  )
}

export default ListItem
